module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-honda.f6f868c3.png";